<template>
  <div>
    <h5>เชื่อมต่อช่องทางโซเชียล</h5>
    <v-layout wrap class="mt-3">
      <v-flex xs6 class="pt-2">
        <em class="fab fa-facebook-square mr-2" /> เชื่อมต่อกับ facebook
      </v-flex>
      <v-flex xs6>
        <div v-if="selectedBot.page_access_token" class="success--text pt-2 pl-2">
          เชื่อมต่อเรียบร้อย
        </div>
        <div v-else class="">ยังไม่ได้เชื่อมต่อ</div>
      </v-flex>
    </v-layout>

    <div
      v-if="selectedBot.page_access_token"
      class="arrow mt-2 pa-2"
      style="border: 1px solid #eee; border-radius: 5px"
    >
      <div class="mr-2" style="display: inline-block">
        <v-avatar class="mr-2">
          <img
            class="responsive-img circle"
            style="min-width: 100%"
            alt
            :src="
              'https://graph.facebook.com/' +
              (selectedBot.facebook_page_id ? selectedBot.facebook_page_id : selectedBot.pageid) +
              '/picture?width=100&height=100&SameSite=None'
            "
            @error="onError"
          />
        </v-avatar>
        <span>{{
          selectedBot.facebook_page_name ? selectedBot.facebook_page_name : selectedBot.pagename
        }}</span>
      </div>
    </div>

    <v-layout wrap class="mt-3">
      <v-flex xs6 class="pt-2">
        <em class="fab fa-instagram mr-2" /> เชื่อมต่อกับ instagram
      </v-flex>
      <v-flex xs6>
        <div v-if="selectedBot.instagram_business_account" class="success--text pt-2 pl-2">
          เชื่อมต่อเรียบร้อย
        </div>
        <div v-else class="">ยังไม่ได้เชื่อมต่อ</div>
      </v-flex>
    </v-layout>

    <div
      v-if="selectedBot.instagram_business_account"
      class="arrow mt-2 pa-2"
      style="border: 1px solid #eee; border-radius: 5px"
    >
      <div class="mr-2" style="display: inline-block">
        <v-avatar class="mr-2">
          <img
            class="responsive-img circle"
            style="min-width: 100%"
            alt
            :src="pictureUrlInstagram"
            @error="onError"
          />
        </v-avatar>
        <span>{{ selectedBot.instagram_name || '' }}</span>
      </div>
    </div>

    <v-layout wrap class="mt-3">
      <v-flex xs6 class="pt-2"> <em class="fab fa-line mr-2" /> เชื่อมต่อกับ LINE </v-flex>
      <v-flex xs6>
        <div
          v-if="selectedBot.line_modular_botid || selectedBot.line_access_token"
          class="success--text pt-2 pl-2"
        >
          เชื่อมต่อเรียบร้อย
        </div>
        <div v-else class="">ยังไม่ได้เชื่อมต่อ</div>
      </v-flex>
    </v-layout>

    <div
      v-if="selectedBot.line_modular_botid"
      class="arrow mt-2 pa-2"
      style="border: 1px solid #eee; border-radius: 5px"
    >
      <div class="mr-2" style="display: inline-block">
        <div class="mr-2" style="display: inline-block">Line Connected</div>
        <!-- <LineProfile :pageid="selectedBot.pageid">
            <template #default="{ loading, botinfo }">
              <div v-if="loading" class="text-xs-center">
                <v-progress-circular indeterminate color="primary lighten-5"></v-progress-circular>
              </div>
              <template v-else>
                <template v-if="botinfo">
                  <v-avatar class="mr-2">
                    <img
                      class="responsive-img circle"
                      style="min-width: 100%"
                      alt
                      :src="botinfo.pictureUrl || '/static/img/assets/livechat/profile.png'"
                      @error="onError"
                    />
                  </v-avatar>
                  <span
                    >{{ botinfo.displayName || selectedBot.line_modular_botid }}
                    <template v-if="botinfo.basicId">({{ botinfo.basicId }})</template></span
                  >
                </template>
                <div v-else class="error--text">เกิดข้อผิดพลาด</div>
              </template>
            </template>
          </LineProfile> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AES from 'crypto-js/aes'
import config from '@/config'

import facebookApi from '@/api/facebook'
import { handleResponse } from '@/api/util'
export default {
  components: {},
  data() {
    return {
      lineUrl: '',
      facebookUrl: '',
      showPageList: false,
      pictureUrlInstagram: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      availablePages: 'availablePages'
    })
  },

  mounted() {
    let line_connect_redirect_uri = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? ':' + window.location.port : ''
    }/connectline`
    let fb_redirect_uri = `${window.location.protocol}//${window.location.hostname}${
      window.location.port ? ':' + window.location.port : ''
    }/autofblogin`

    this.getInstagramDetail()
    let query = []

    let state = {
      userid: this.$store.state.userid,
      pageid: this.selectedBot.pageid,
      lang: this.currentLang,
      type: 'connect'
    }

    for (const key in state) {
      if (key != 'state' && key) query.push(`${key}=${state[key]}`)
    }

    let querystring = query.join(',')

    this.facebookUrl = `https://www.facebook.com/v10.0/dialog/oauth?client_id=${
      config.appid
    }&scope=${
      config.fb_scope
    }&return_scopes=true&response_type=token&redirect_uri=${encodeURIComponent(fb_redirect_uri)}`
    if (query && query.length > 0) this.facebookUrl = this.facebookUrl + `&state={${querystring}}`

    let encrypt_query = ''

    encrypt_query = AES.encrypt(querystring, 'awesomezwizai').toString()

    //client id
    //sme 1656036711
    //enterpise 1656186798
    this.lineUrl = `https://manager.line.biz/module/auth/v1/authorize?response_type=code&client_id=1656186798&redirect_uri=${line_connect_redirect_uri}&scope=account:manage%20message:mark_as_read%20message:receive%20message:send%20profile:read&state=${encrypt_query}`
  },
  methods: {
    async getInstagramDetail() {
      let response = await facebookApi.getInstagramDetail({
        params: {
          access_token: this.$store.state.selectedBot.page_access_token
        }
      })
      await handleResponse(response)
      if (response && response.instagram_business_account) {
        this.pictureUrlInstagram = response.instagram_business_account.profile_picture_url
      }
    },
    async onConfirmSubscribe(page) {
      let result = await this.$swal.fire({
        title: this.$t('Do you want to connect this social to this chatbot?'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        let data = {
          adminid: this.$store.state.userid,
          pageid: this.selectedBot.pageid,
          page_access_token: page.access_token,
          type: 'connect_facebook_page'
        }
        try {
          let response = await this.post('admin/connect', data, {}, false)
          if (response.success) {
            await this.$swal.fire({
              title: this.$t('Success'),
              type: 'success',
              confirmButtonText: this.$t('Confirm')
            })
          }
          window.location.reload()
        } catch (error) {
          console.error(error)
        }
        this.showPageList = false
      }
    },
    logout() {
      var isFacebook = this.isFacebook
      this.$store.dispatch('logout', null).then()
      if (isFacebook) {
        this.$router.push('/' + this.currentLang + '/login')
      } else {
        this.$router.push('/' + this.currentLang + '/nigol')
      }
    },
    onError: function (event) {
      event.target.src = '/static/img/assets/livechat/profile.png'
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/SocialConnect.vue